import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subscription } from 'rxjs';
import { InstanceDataService } from 'src/app/services/instance-data.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { ResultType } from '../../../../../../models/enums/result-type.enum';
import { IceapiService } from '../../../../../../services';
import { CustomToastService } from '../../../../../../services/custom-toast.service';
import { AllowedItem } from '../../../../models/informate/allowed-item';
import { AllowedItems } from '../../../../models/informate/allowed-items';
import { InstanceDataComponent } from '../instance-data/instance-data.component';
import { InstanceSidebarComponent } from '../instance-sidebar/instance-sidebar.component';
export class BreadcrumbData {
    id: string;
    name: string;
    layer?: number;
}

export class AllowedItemChange {
    allowed: boolean;
    itemIds: string[];
}
@Component({
    selector: 'app-instance-configuration',
    templateUrl: './instance-configuration.component.html',
    styleUrls: ['./instance-configuration.component.scss'],
})
export class InstanceConfigurationComponent implements OnInit {
    @Input()
    set saveAllowedItems(value: boolean) {
        if (value == true) {
            this.postAllowedItems(localStorage.getItem('currentInstanceId'));
            this.cd.markForCheck();
        }
    }

    @Output() enableSaveButton: EventEmitter<boolean> = new EventEmitter();
    @ViewChild('child1', { static: true }) child1: InstanceSidebarComponent;
    @ViewChild('child2', { static: true }) child2: InstanceDataComponent;

    allowedItem: AllowedItems;
    selectedAllowedItemList: AllowedItem[];
    breadcrumbData: BreadcrumbData[];
    result: ResultType = ResultType.Error;
    layer: number = 0;
    CurrentlayerSub: Subscription;
    instanceid: any;
    constructor(
        private iceSvc: IceapiService,
        private cd: ChangeDetectorRef,
        private customToastService: CustomToastService,
        private route: ActivatedRoute,
        private router: Router,
        private ngxUiLoaderService: NgxUiLoaderService,
        private instanceDataService: InstanceDataService,
        private user_utility: UserUtilityService
    ) {}

    ngOnInit(): void {
        this.getAlloweditems(localStorage.getItem('currentInstanceId'));
        this.CurrentlayerSub = this.instanceDataService.currentLayer.subscribe((layer: number) => {
            this.layer = layer;
        });
    }

    async getAlloweditems(instanceid: any) {
        this.ngxUiLoaderService.start();
        await this.iceSvc
            .getAlloweditems(instanceid)
            .toPromise()
            .then(
                (res) => {
                    if (res.success === true) {
                        this.ngxUiLoaderService.stop();
                        this.allowedItem = res.response;
                    } else {
                        this.user_utility.errorModelPopup(res.message);
                    }
                },
                (err) => {
                    this.ngxUiLoaderService.stop();
                }
            );
        this.cd.markForCheck();
    }

    allowedItemTypeHandler(allowedItemTypeId: string) {
        this.selectedAllowedItemList = this.allowedItem.allowedItemTypes.find((x) => x.allowedItemTypeId == allowedItemTypeId).items;
        this.breadcrumbData = [
            { id: allowedItemTypeId, name: this.allowedItem.allowedItemTypes.find((x) => x.allowedItemTypeId == allowedItemTypeId).name, layer: this.layer },
        ];
        this.LoadFeatures(this.selectedAllowedItemList);
    }

    dataChangeEventHandler(data: AllowedItemChange) {
        let selected: AllowedItem[];
        for (let i = 0; i < data.itemIds.length; i++) {
            if (i == 0) {
                selected = this.allowedItem.allowedItemTypes.find((x) => x.allowedItemTypeId == data.itemIds[i]).items;
            } else {
                if (selected.find((x) => x.itemId == data.itemIds[i]).items != undefined) {
                    selected = selected.find((x) => x.itemId == data.itemIds[i]).items;
                } else {
                    selected = selected.filter((x) => x.itemId == data.itemIds[i]);
                }
            }
        }

        this.updateItems(selected, data);
        this.enableSaveButton.emit(true);
    }

    async postAllowedItems(instanceId: any) {
        this.result = await this.iceSvc.postAlloweditems(this.allowedItem, instanceId).toPromise();
        this.displayToast();
        this.getAlloweditems(localStorage.getItem('currentInstanceId'));
    }

    displayToast() {
        if (this.result === 1) {
            this.customToastService.successToast('User settings updated!', 'Success');

            setTimeout(() => {
                this.router.routeReuseStrategy.shouldReuseRoute = () => false;
                this.router.onSameUrlNavigation = 'reload';
                this.router.navigate(['./'], { relativeTo: this.route });
            }, 3000);
        } else {
            this.customToastService.errorToast('Unable to update settings...', 'Error');
        }
    }

    private updateItems(allowedItems: AllowedItem[], data: any) {
        for (let item of allowedItems) {
            if (item.items == undefined || item.items == null) {
                item.allowed = data.allowed;
            } else {
                this.updateItems(item.items, data.allowed);
            }
        }
    }
    postAllowedItemstoInformate(instanceid: any) {
        this.ngxUiLoaderService.start();
        this.iceSvc
            .postAlloweditems(this.allowedItem, instanceid)
            .toPromise()
            .then(
                (res) => {
                    this.ngxUiLoaderService.stop();
                },
                (err) => {
                    this.ngxUiLoaderService.stop();
                }
            );
    }

    loadDataClicked(allowedItem) {
        this.child2.loadDataBySelected(allowedItem);
    }

    _loadDataClicked(allowedItem) {
        this.child1._loadDataBySelected(allowedItem);
    }

    _refreshDataClicked(id: string) {
        this.child1._loadDataAfterrefresh(id);
    }

    LoadFeatures(allowedItem) {
        this.child2._LoadFeatures(allowedItem);
    }
}
